export enum NativeEnvironmentPlatform {
  All = 'all',
  iOS = 'ios',
  Android = 'android',
}
